import { useWorkpaperContext } from '../providers/WorkpaperProvider';
import { WorkpaperRoleEnum } from '../types/workpaper';

type WorkpaperRoleResult = { isApprover: boolean; isReviewer: boolean; isPreparer: boolean; isGuest: boolean };

export function useIsWorkpaperRole(): WorkpaperRoleResult {
    const { role } = useWorkpaperContext();

    return {
        isApprover: role === WorkpaperRoleEnum.APPROVER,
        isReviewer: role === WorkpaperRoleEnum.REVIEWER,
        isPreparer: role === WorkpaperRoleEnum.PREPARER,
        isGuest: role === WorkpaperRoleEnum.GUEST,
    };
}
